const colorDetails = {
	orange: {
		brightColor: "#ffd899",
		mediumColor: "#FFF1DB",
		lightColor: "#fffbf5",
	},
	blue: {
		brightColor: "#99f5ff",
		mediumColor: "#CCFAFF",
		lightColor: "#f5feff",
	},
	purple: {
		brightColor: "#e899ff",
		mediumColor: "#F7DBFF",
		lightColor: "#fdf5ff",
	},
};

const projectDetails = [
	{
		title: "Convert It",
		type: "Web Applications", // orange
		description:
			"Our web app quickly converts numbers between different systems (binary, octal, decimal, and hexadecimal) with a simple and user-friendly interface.",
		imgSrc: require("../../assets/project-image-1.png"),
		projectNo: "01.",
		btnLink: "https://digitwise.web.app/",

		brightColor: colorDetails.orange.brightColor,
		mediumColor: colorDetails.orange.mediumColor,
		lightColor: colorDetails.orange.lightColor,
	},
	{
		title: "Convert It",
		type: "Web Applications", // orange
		description:
			"Our web app quickly converts numbers between different systems (binary, octal, decimal, and hexadecimal) with a simple and user-friendly interface.",
		imgSrc: require("../../assets/project-image-1.png"),
		projectNo: "02.",
		btnLink: "https://digitwise.web.app/",

		brightColor: colorDetails.orange.brightColor,
		mediumColor: colorDetails.orange.mediumColor,
		lightColor: colorDetails.orange.lightColor,
	},
	{
		title: "Convert It",
		type: "Web Development", // blue
		description:
			"Our web app quickly converts numbers between different systems (binary, octal, decimal, and hexadecimal) with a simple and user-friendly interface.",
		imgSrc: require("../../assets/project-image-1.png"),
		projectNo: "03.",
		btnLink: "https://digitwise.web.app/",

		brightColor: colorDetails.blue.brightColor,
		mediumColor: colorDetails.blue.mediumColor,
		lightColor: colorDetails.blue.lightColor,
	},
	{
		title: "Convert It",
		type: "UI/UX Design", // purple
		description:
			"Our web app quickly converts numbers between different systems (binary, octal, decimal, and hexadecimal) with a simple and user-friendly interface.",
		imgSrc: require("../../assets/project-image-1.png"),
		projectNo: "04.",
		btnLink: "https://digitwise.web.app/",

		brightColor: colorDetails.purple.brightColor,
		mediumColor: colorDetails.purple.mediumColor,
		lightColor: colorDetails.purple.lightColor,
	},
];

export default projectDetails;
